"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isDefined;

var _isNil = _interopRequireDefault(require("lodash-es/isNil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isDefined(value) {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (_typeof(value) === 'object' && value !== null) {
    var nestedValues = Object.values(value).filter(isDefined);
    return nestedValues.length > 0;
  }

  return !(0, _isNil["default"])(value);
}